import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getAddressApi from "api/rest/address/getAddressApi";
import { ShipperAddress } from "api/rest/address/types";
import { PaymentPayer, PaymentTerms, Smc3Carrier, Smc3Currency } from "api/rest/smc3/types";
import usableActions from "utils/store/usableActions";

type Smc3IntegrationsSliceState = {
  search: string;
  username?: string | undefined;
  password?: string | undefined;
  securityCode?: string | undefined;
  key?: string | undefined;
  secret?: string | undefined;
  trackingSecret?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  selectedCarrier?: Smc3Carrier | undefined;
  dialogOpen: boolean;
  paymentPayer?: PaymentPayer;
  paymentTerms?: PaymentTerms;
  paymentCurrency?: Smc3Currency;
  billToAccountNumber?: string;
  billToAddressId?: number;
  billingName?: string;
  address: Partial<ShipperAddress>;
  isCreated: boolean;
};

const initialState: Smc3IntegrationsSliceState = {
  search: "",
  dialogOpen: false,
  address: {},
  isCreated: false,
};

const sliceName = "smc3IntegrationsSlice";

const smc3IntegrationsSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setState: (state, action: PayloadAction<Partial<Smc3IntegrationsSliceState>>) => {
      const address = { ...state.address, ...action.payload.address };
      return { ...state, ...action.payload, address };
    },
    resetDialogState: (state) => {
      return { ...initialState, search: state.search };
    },
  },
  extraReducers(builder) {
    builder.addMatcher(getAddressApi.endpoints.getAddress.matchFulfilled, (state, action) => {
      state.address = action.payload.data.address;
    });
  },
});

export const { useSetState, useResetDialogState } = usableActions(smc3IntegrationsSlice.actions);
export default smc3IntegrationsSlice;
